<template>
  <v-dialog v-model="dialog" max-width="60%">
    <template #activator="{ on }">
      <v-btn outlined v-on="on" rounded color="primary">
        <v-icon left>edit</v-icon>
        Edit Notes
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Edit {{ batch.forgeID }} Run Notes
        <v-spacer />
        <v-btn icon @click="dialog = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-textarea
            prepend-icon="note"
            v-model="formnotes"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="dialog = close" text>
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn @click="submit" text color="success" :loading="loading">
          <v-icon>save</v-icon>
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Batch from "../../models/Batch";
export default {
  name: "BatchRunNotesEdit",
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialog: false,
      formnotes: this.batch.runnotes
    }
  },
  methods: {
    submit() {
      this.loading = true;
      Batch
        .$put(this.batch.id, { runnotes: this.formnotes })
        .then(() => {
          this.loading = false;
          this.dialog = false;
        })
    }
  }
}
</script>